var cashIcon = "https://shopfront-cdn.tekoapis.com/static/d12aea6196b95560.svg";

export { cashIcon as default };
